<template>
  <VLayout>
    <VFlex xs8>
      <VCard style="height: calc(100vh - 100px)">
        <VLayout justify-space-around row>
          <VFlex xs6>
            <VCardTitle style="font-variant: small-caps">
              <h1>Načini plačila</h1>
              <v-spacer />
            </VCardTitle>
            <VContainer class="pa-0" fill-height fluid>
              <VLayout fill-height>
                <VFlex xs12>
                  <VDataTable
                    :headers="headers"
                    :items="paymentTypes"
                    rows-per-page-text="Vrstic na stran"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs">{{ props.item.name }}</td>
                      <td class="text-xs">{{ props.item.mapping }}</td>
                      <td class="text-xs-center">
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="green"
                            @click.stop="startEditingPaymentType(props.item)"
                          >
                            <VIcon>edit</VIcon>
                          </VBtn>
                          <span>Uredite pravilo</span>
                        </VTooltip>
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="red"
                            @click.stop="deletePaymentType(props.item)"
                          >
                            <VIcon>delete</VIcon>
                          </VBtn>
                          <span>Izbrišite način plačila</span>
                        </VTooltip>
                      </td>
                    </template>
                    <template slot="no-data"> Ni podatkov </template>
                  </VDataTable>
                </VFlex>
              </VLayout>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
    <VFlex xs4>
      <VCard style="height: calc(100vh - 100px); overflow-y: scroll">
        <VLayout justify-space-around row>
          <VFlex xs10>
            <VCardTitle style="padding: 10px 0 0 0; font-variant: small-caps; margin-bottom: 10px">
              <h2>{{ editing ? 'Uredi način plačila' : 'Dodaj način plačila' }}</h2>
            </VCardTitle>
            <VContainer fluid style="padding: 0 0 0 10px">
              <VLayout fill-height row wrap>
                <VFlex xs12>
                  <VTextField
                    v-model="paymentTypeObject.name"
                    label="Ime načina plačila"
                    type="string"
                  />
                </VFlex>
                <VTextField
                  v-model="paymentTypeObject.mapping"
                  label="Šifra načina plačila"
                  type="string"
                />
                <v-flex xs12 style="display: flex; justify-content: flex-end">
                  <VBtn v-if="editing" @click.stop="stopEditing()"> Prekliči urejanje </VBtn>
                  <VBtn
                    color="primary"
                    :disabled="!paymentTypeObject.name || !paymentTypeObject.mapping"
                    @click="createOrEditPaymentType()"
                  >
                    Potrdi
                  </VBtn>
                </v-flex>
                <v-alert
                  :value="paymentTypeError"
                  transition="scroll-x-transition"
                  type="warning"
                  outline
                  style="margin: 0px; width: 98%"
                >
                  {{ paymentTypeError }}
                </v-alert>
              </VLayout>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  name: 'PaymentTypes',
  data() {
    return {
      headers: [
        {
          text: 'Ime',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Šifra',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Akcije',
          align: 'middle',
          sortable: false,
        },
      ],
      loading: false,
      editing: false,
      paymentTypeObject: {
        name: '',
        mapping: '',
      },
      emptyPaymentTypeObject: {
        name: '',
        mapping: '',
      },
      paymentTypeError: '',
    };
  },
  computed: {
    ...mapGetters({
      paymentTypes: 'paymentTypes',
    }),
  },
  mounted() {
    this.getPaymentTypesAction();
  },
  methods: {
    ...mapActions([
      'setSnackBarStateAction',
      'createPaymentTypeAction',
      'editPaymentTypeAction',
      'removePaymentTypeAction',
      'getPaymentTypesAction',
    ]),
    showSnackbar(successful, msg) {
      const snackbarColor = successful ? 'green' : 'red';
      this.setSnackBarStateAction({
        snackBar: true,
        color: snackbarColor,
        text: msg,
      });
    },
    stopEditing() {
      this.editing = false;
      this.paymentTypeObject = cloneDeep(this.emptyPaymentTypeObject);
    },
    startEditingPaymentType(item) {
      this.paymentTypeObject = cloneDeep(item);
      this.editing = true;
    },
    async deletePaymentType(item) {
      try {
        await this.removePaymentTypeAction(item);
        this.showSnackbar(true, `Način plačila je bil uspešno izbrisan.`);
      } catch (err) {
        this.showSnackbar(
          false,
          `Napaka pri izbrisu načina plačila. Poskusite znova ali kontaktirajte administratorja.`
        );
      }
    },
    async createOrEditPaymentType() {
      this.paymentTypeObject.name = this.paymentTypeObject.name.trim();
      this.paymentTypeObject.mapping = this.paymentTypeObject.mapping.trim();

      if (
        this.paymentTypeObject.mapping.length > 3 ||
        !Number.isInteger(Number(this.paymentTypeObject.mapping))
      ) {
        this.paymentTypeError = 'Šifra ima lahko največ 3 mesta!';
        setTimeout(() => {
          this.paymentTypeError = '';
        }, 3000);
        return;
      }

      try {
        if (this.editing) {
          await this.editPaymentTypeAction(this.paymentTypeObject);
        } else {
          await this.createPaymentTypeAction(this.paymentTypeObject);
        }
        this.showSnackbar(
          true,
          `Način plačila je bil uspešno ${this.editing ? 'urejen' : 'dodan'}.`
        );
        this.stopEditing();
      } catch (err) {
        if (err.response.data['mapping'][0].endsWith('že obstaja.')) {
          this.showSnackbar(false, `Način plačila s to šifro že obstaja`);
          return;
        }
        this.showSnackbar(
          false,
          `Napaka pri ${
            this.editing ? 'urejanju' : 'dodajanju'
          } načina plačila. Poskusite znova ali kontaktirajte administratorja.`
        );
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-table__overflow {
  overflow: auto;
  max-height: 70vh;
}
</style>
